'use strict';

const action = require('./header/action');
const type = require('./header/type');
const style = require('./header/style');

/**
 * header classes
 * @type {Object}
 * @namespace cheetahGrid.headers
 * @memberof cheetahGrid
 */
module.exports = {
	action,
	type,
	style,
};
